<!--考试成绩报告-->
<template>
  <div class="hbn-container">
    <div class="search-form">
      <el-form
        label-width="80px"
        label-position="right"
        size="mini"
      >
        <el-row :gutter="24">
          <el-col :span="18">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="试卷名称">
                  <el-input
                    id="title"
                    v-model="PageQuery.queryModel.examName"
                    placeholder="试卷名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="考试成员">
                  <el-input
                    id="title"
                    v-model="PageQuery.queryModel.userName"
                    placeholder="请输入"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    id="title"
                    v-model="PageQuery.queryModel.phone"
                    placeholder="请输入"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="show" :gutter="24">
              <el-col :span="12">
                <el-form-item label="省-市">
                  <el-select
                    style="width: 49%"
                    v-model="PageQuery.queryModel.provinceId"
                    filterable
                    placeholder="请选择省"
                    @change="ProvinceChange"
                  >
                    <el-option
                      v-for="item in ProvinceList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    style="width: 50%"
                    v-model="PageQuery.queryModel.cityId"
                    filterable
                    placeholder="请选择市"
                  >
                    <el-option
                      v-for="item in CityList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否合格">
                  <el-select
                    v-model="PageQuery.queryModel.isPass"
                  >
                    <el-option label="请选择" value="-1"></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button
                size="mini"
                class="hbn-button-serach"
                @click="seach"
              >查找</el-button>
              <span
                class="control-collapse"
                @click="show = !show"
              >{{
              show ? "收起" : "展开"
            }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          type="primary"
          class="custom-button"
          @click="exportExcel"
        >
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
        <!-- <el-button
          class="custom-button"
          type="primary"
        >
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
        <el-button
          class="custom-button"
          type="primary"
        >
          <span @click="goDetail()">数据中心详情测试</span>
        </el-button> -->
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template
              v-for="(item, key) in ExamDataList"
              :key="key"
            >
              <vxe-table-column
                v-if="item.isShow"
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="200"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row }">
                <el-button
                  type="text"
                  size="small"
                  @click="goDetail(row)"
                >查看</el-button>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import XEUtils from "xe-utils";
import {ExamResultList} from "@/assets/apiData/Exam/ExamDataCenterList";

import {GetDataExamResultListByPageQuery, ExportExamResult} from "@api/Exam/ApiExamDataCenter";
import { dateFormat } from "@/util/utils.js";
import Enumerable from "linq";
import { ProvinceList } from "@/assets/apiData/Province";

export default {
  name: "ExamDataCenter",
  data() {
    return {
      PageQuery: {
        queryModel: {
          title: "",
          isPass: "-1",
          phone: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      show: false,
      ExamDataList: [],
      DataList: [],
      ProvinceList: [],
      CityList: [],
    };
  },
  components: {},
  methods: {
    ProvinceChange() {
      this.PageQuery.queryModel.cityId = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.PageQuery.queryModel.provinceId) {
          this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "isPass":
          cellValue = cellValue?"是":"否";
          break;
      }
      return cellValue;
    },
    //选中事件
    handleSelectionChange({ records }) {
      this.multipleSelection = records;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      //this.GetData();
    },
    GetData() {
      const _this = this;
      const loading = this.loading()
      try {
        GetDataExamResultListByPageQuery(this.PageQuery).then(function (
          data
        ) {
          loading.close();
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        loading.close();
        console.log(e);
      }
    },
    goDetail(row){
      localStorage.removeItem('ExamDataCenter_ExamResult')
      localStorage.setItem('ExamDataCenter_ExamResult', JSON.stringify(row));
      this.$router.push({
        name: "考试成绩报告详情",
        params: {
          from: "ExamDataCenter",
          isReplace: true,
        },
      });
    },
    exportExcel() {
      if (this.multipleSelection.length == 0) {
        try {
          let _this = this;
          ExportExamResult(_this.PageQuery.queryModel).then((result) => {
            if (result.response.status == 500) {
              this.$message.warning("查询到的数据为空");
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        this.export2Excel();
      }
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.ExamResultList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.ExamResultList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名

        const list =
          v.multipleSelection.length == 0 ? v.DataList : v.multipleSelection;

        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `考试成绩报告`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
  mounted() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
    this.ExamDataList = ExamResultList
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>